import {Component, Input, Output, EventEmitter, SimpleChanges, ViewChild, OnChanges, OnInit} from '@angular/core';
import {EnvService} from "../services/env.service";
import {HttpClient, HttpParams} from "@angular/common/http";
import {AuthService} from "../services/auth.service";
import {MicroSelectComponent} from "../shared/select/micro-select.component";
import {ControlValueAccessor, NG_VALUE_ACCESSOR} from "@angular/forms";
import {debounceTime} from "rxjs/operators";

@Component({
  selector: 'micro-ne-select',
  templateUrl: './ne-select.component.html',
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      multi:true,
      useExisting: NeSelectComponent
    }
  ]
})
export class NeSelectComponent implements OnInit, OnChanges, ControlValueAccessor  {

  @ViewChild("sel", {static: true}) sel:MicroSelectComponent;

  @Input()
  mode:string = 'simple';

  @Output()
  neIdChange:EventEmitter<any> = new EventEmitter<any>();

  @Input()
  neId:any;

  @Input()
  negId:any;

  @Input()
  netId:any;

  @Input()
  siteId:any;

  @Input()
  placeholder:any = 'NE';

  @Output()
  valueChange:EventEmitter<any> = new EventEmitter<any>();

  @Output()
  neChange:EventEmitter<any> = new EventEmitter<any>();

  @Input()
  value:any = '';

  @Input()
  required:boolean = false;

  @Input()
  disabled:boolean = false;

  @Input()
  jump:boolean = true;

  @Input()
  picklist:boolean = false;

  options:any[];

  reloadDebouncer:EventEmitter<any> = new EventEmitter<any>();

  onChange = (neId) => {};
  onTouched = () => {};


  change(e) {
    let ne = undefined;
    if (e) {
      ne = this.options.find(o => o.id === e);
      if (ne) {
        this.neId = ne.id;
      }
    }
    this.onChange(e);
    this.neIdChange.emit(e);
    this.neChange.emit(ne)
    this.valueChange.emit(this.sel.getSelectedValue());
  }

  constructor(private auth:AuthService, private env:EnvService, private http:HttpClient) {
  }

  ngOnChanges(changes: SimpleChanges): void {
    let changed = false;
    for (let prop in changes) {
      if (prop === 'negId'
        || prop === 'netId'
        || prop === 'siteId') {

        var change = changes[prop];
        changed = changed || change.currentValue !== change.previousValue;
      }
    }
    if (changed) this.reloadDebounced();
  }

  registerOnChange(onChange: any): void {
    this.onChange = onChange;
  }

  registerOnTouched(onTouched: any): void {
    this.onTouched = onTouched;
  }

  writeValue(neId: string): void {
    this.neId = neId;
  }

  ngOnInit(): void {
    this.reloadDebouncer.pipe(debounceTime(10)).subscribe(change => {
      this.reload();
    });
    this.reloadDebounced();
  }

  reloadDebounced() {
    this.reloadDebouncer.emit();
  }

  reload() {
    let params:HttpParams = new HttpParams();

    if (this.negId && this.negId !== '') {
      params = params.set("negId", this.negId);
    }
    if (this.netId && this.netId !== '') {
      params = params.set("netId", this.netId);
    }
    if (this.siteId && this.siteId !== '') {
      params = params.set("siteId", this.siteId);
    }

    this.sel.loading = true;
    return this.http.get(`${this.env.e.url}/domain/nes/all`, {params:params})
      .subscribe(data => {
        this.options = data as any[]
        this.sel.loading = false;
        if (this.siteId && this.siteId !== '' && this.options.length === 1) {
          this.change(this.options[0].id);
        }
      });
  }

}
